import {useState} from 'react';
import {EvReactModal} from '../modal/EvReactModal';
import {ManualPriceIncreaseForm} from './manual-price-increase-form';
import {ManualPriceUpdateProps} from './manual-price-update.model';

export function ManualPriceIncrease(props: ManualPriceUpdateProps) {
  const [state, stateSet] = useState<{ modalState: 'open' | 'closed' }>({modalState: 'closed'});

  const onUpdated: () => void = () => {
    stateSet({...state, modalState: 'closed'});
    props.onUpdated();
  };

  const openModal: () => void = () => {
    stateSet({...state, modalState: 'open'});
  };

  return <>
    {
      props.labelButton === 'Preise erhöhen' ?
        <button type="button" className="btn btn-link btn-after-headline" onClick={openModal}>
          Alle Manuellen Preise erhöhen
        </button> :
        <button type="button" className="btn btn-link" title="Preiserhöhung öffnen" onClick={openModal}>
          <i className="fa fa-percent"></i>
        </button>
    }

    <EvReactModal contentLabel={
      props.labelButton === 'Preise erhöhen' ? 'Alle manuellen Preise erhöhen' : props.labelButton
    }
                  showModal={state.modalState === 'open'}
                  modalClosed={() => stateSet({...state, modalState: 'closed'})}>
      <ManualPriceIncreaseForm {...props} onUpdated={onUpdated}/>
    </EvReactModal>
  </>;
}
